var AfterpayModel = (function (Backbone) {
	return Backbone.Model.extend({
		defaults: {
			Description: null,
			IsAvailable: null
		}
	});
})(Backbone);
